/**
 * Applies a watermark to an image for free-tier users.
 * Returns the watermarked image as a base64 data URL.
 */
export const applyWatermark = async (imageUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Failed to get canvas context"));
        return;
      }

      // Draw the original image
      ctx.drawImage(img, 0, 0);

      // Calculate font size based on image dimensions (responsive watermark)
      const fontSize = Math.max(20, Math.min(img.width, img.height) * 0.04);
      const padding = fontSize * 1.2;

      // Add semi-transparent background strip
      ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
      ctx.fillRect(0, img.height - padding * 1.5, img.width, padding * 1.5);

      // Add watermark text
      ctx.fillStyle = "rgba(255, 255, 255, 0.9)";
      ctx.font = `bold ${fontSize}px Arial, sans-serif`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(
        "Decor Canvas - Free Tier",
        img.width / 2,
        img.height - padding * 0.75
      );

      // Return as data URL (JPEG for smaller size)
      resolve(canvas.toDataURL("image/jpeg", 0.92));
    };

    img.onerror = () => reject(new Error("Failed to load image for watermarking"));
    img.src = imageUrl;
  });
};

/**
 * Extracts the base64 data from a data URL (removes the prefix).
 */
export const extractBase64FromDataUrl = (dataUrl: string): string => {
  const base64Index = dataUrl.indexOf(",");
  if (base64Index === -1) return dataUrl;
  return dataUrl.substring(base64Index + 1);
};
